<template>
  <div>
    <div @click="toggle">
      <slot></slot>
    </div>
    <div :style="{ height: show ? '100%' : 0 }" class="ver-select">
      <div class="line"></div>
      <div class="dd_title">- 请选择版本 -</div>
      <div class="grade-content">
        <Grid :cols="2" row-margin="0.53rem" col-margin="0.27rem">
          <GridItem v-for="(item, index) in verisonData" :key="index">
            <div
              class="grade-item"
              :class="{ 'grade-active': selected.indexOf(item.id) > -1 }"
              @click="select(item, index)"
            >
              <span>{{ item.wbVersion }}</span>
            </div>
          </GridItem>
        </Grid>
      </div>
      <div class="confirm">
        <div class="comfirm-button" @click.stop="confirm">确定</div>
      </div>
    </div>
  </div>
</template>
<script>
import { lockScroll } from '@/static/js/zjs'
import Grid from '@/components/Grid'
import { getKey, saveKey } from '@/static/js/zjs'

export default {
  components: {
    Grid,
    GridItem: Grid.item
  },
  model: {
    prop: 'version', // 默认 value
    event: 'selectVer' // 默认 input
  },
  props: {
    version: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      show: this.version === '选择版本',
      verisonData: {},
      selected: this.version.split(',') || []
    }
  },
  mounted() {
    this.getVersionList()
  },
  methods: {
    getVersionList() {
      const verisonData = getKey('verisonData')
      if (!verisonData) {
        this.$http.get('/cms/upload/wbversion/version.json').then((res) => {
          saveKey('verisonData', res.data, 1)
          this.dataChange(res.data)
        })
      } else {
        this.dataChange(verisonData.value)
      }
    },
    dataChange(data) {
      this.verisonData = data.map((item) => {
        item.id = 'ver' + item.id
        return item
      })
      if (this.version === 'all') {
        this.selected = this.verisonData.map((item) => {
          return item.id
        })
      }
    },
    toggle() {
      this.show = !this.show
      if (this.show) {
        lockScroll().lock()
      } else {
        lockScroll().unLock()
      }
    },
    // 版本选择点击函数，多选
    select(item, index) {
      const find = this.selected.findIndex((val) => val === item.id)
      // 再次点击取消
      if (find > -1) {
        this.selected.splice(find, 1)
      } else {
        this.selected.push(item.id)
      }

    },
    confirm() {
      this.toggle()
      this.$emit('grade-change', this.selected)
      this.$emit('on-confirm', this.selected)
    }
  }
}
</script>
<style lang="scss">
.ver-select {
  overflow: hidden;
  position: fixed;
  left: 0;
  right: 0;
  top: 80px;
  z-index: 100;
  background-color: #ffffff;
  transition: all 0.2s ease-in-out;
  .line {
    height: 7px;
    background: #f5f5f5;
  }
  .dd_title {
    font-weight: 500;
    font-size: 18px;
    margin-top: 19px;
    margin-bottom: 17px;
    line-height: 1;
  }
  .center {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .grade-content {
    margin-top: 17px;
    padding: 0 43px;
  }
  .grade-item {
    width: 125px;
    height: 39px;
    background: rgba(247, 247, 247, 1);
    border-radius: 0.48rem;
    @extend .center;
    span {
      height: 0.37rem;
      font-size: 0.37rem;
      font-weight: 400;
      color: #454d52;
      line-height: 0.37rem;
    }
  }
  .grade-active {
    background: #ffebed;
    span {
      color: #ff0000;
    }
  }
  .confirm {
    position: absolute;
    bottom: 80px;
    width: 100%;
    height: 1.6rem;
    background: rgba(255, 255, 255, 1);
    @extend .center;
    .comfirm-button {
      width: 9.15rem;
      height: 44px;
      background: #ff0000;
      border-radius: 0.53rem;
      font-size: 0.43rem;
      font-weight: 500;
      color: rgba(254, 255, 254, 1);
      @extend .center;
    }
  }
}
</style>
